export const bgColors = async () => {
    colorsSliderProducts();
    scrollColors();
    background();
}

const scrollColors = () =>{
    let pathname = window.location.pathname;
    if(pathname == '/'){
        let container = document.querySelector('.container--general') as HTMLElement;
        window.onscroll = function() {
            background();
            let y = window.scrollY;
            {y == 0 ? container.classList.add('page-home') : container.classList.remove('page-home') }
        };
    }else{
        window.onscroll = function() {
            background();
        };
    }
    
}

const background = () =>{
    let colors = document.querySelectorAll('.bg-background-animate') as any; 
    let backgrounds = [...colors];
    let count = 1;
    for(let i=0; i < backgrounds.length; i++){
        let element = backgrounds[i];
        
        const isInViewport = (el:any) =>{
            let distance = el.getBoundingClientRect();
            return (
                Math.round(distance.top) < (window.innerHeight || document.documentElement.clientHeight) && distance.bottom > 0
            );
        }

        if (isInViewport(element)) {
            element.classList.add('bg-background-animate--play');
            element.classList.add(`bg-background-animate--play--delay--${count}`);
        }
        
        count == 3 ? count = 1 : count++; 
    }
}

const colorsSliderProducts = () => {
    let backgrounds = document.querySelectorAll('.setbgcolor') as any;
    if(backgrounds.length > 0){
        backgrounds.forEach((element:any) => {
            element.setAttribute("style", `background-color: ${element.getAttribute("data-bgcolor")};`);
        });
    }
}